import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, PaymentRecord, PaymentType, PaymentState, PartnerRecord } from '@core/services/data.service';
import { NumberInputComponent } from '@common/UI/number-input/number-input.component';

@Component({
  templateUrl: './customer-payment-editor.component.html',
  styleUrls: ['./customer-payment-editor.component.scss']
})
export class CustomerPaymentEditorComponent implements OnInit {

  constructor(private modal: ModalService, private ds: DataService) { }

  @Input()
  public partner: PartnerRecord;

  @Input()
  public mode: 'income' | 'expense' = 'income';

  ngOnInit(): void {

    this.payment = {
      ID: 0,
      PartnerID: this.partner.ID,
      Type: (this.mode == 'income' ? PaymentType.Income : PaymentType.Expense) | PaymentType.Partner,
      State: PaymentState.Confirmed,
      SendAmount: 0,
      SendSymbol: "VND",
      ReceiveAmount: 0,
      ReceiveSymbol: "VND",
      Notes: '',
      CreatorID: 0,
      UpdatorID: 0,
      FirstStamp: 0,
      LastStamp: 0,
      Stamp: new Date().getTime()
    };
  }

  @Output()
  public create = new EventEmitter<PaymentRecord>();

  public payment: PaymentRecord = null; 

  public get time(): Date {
    return new Date(this.payment.Stamp);
  }

  public set time(date: Date) {
    this.payment.Stamp = date.getTime();
  }

  public close() {
    this.modal.of(this).hide();
  }

  public update(editor: NumberInputComponent) {
    if (isNaN(editor.value)) editor.value = 0;

    this.payment.SendAmount = this.payment.ReceiveAmount = editor.value;
  }

  public save() {
    if (this.payment.SendAmount > 0 && this.payment.ReceiveAmount > 0) {
      this.ds.payments('create', this.payment).subscribe(payments => {
        if (payments && payments.length == 1) {
          this.create.emit(payments[0]);
          this.close();
        }
      });
    }
  }

}
